import { EmeraldIcon } from "@emerald-react/icon";
import { SurveyContact } from "@survey-types/survey.contacts.types";

interface ContactListPreviewProps {
  contacts: SurveyContact[];
}

const ContactListPreview = (props: ContactListPreviewProps) => {
  const { contacts } = props;
  return (
    <div className="p-4">
      <h3 className="text-[8px] mb-4 text-default">Your CBRE Team</h3>
      <ul className="">
        {contacts.map((contact) => (
          <li
            key={contact.contactId}
            className="text-tiny text-default mt-4 pb-4 border-b border-brand-sage"
          >
            {contact.name && (
              <h6 className="text-[17px] font-medium text-primary p-1 font-heading leading-4">
                {contact.name}
              </h6>
            )}
            {contact.title && (
              <p className="text-xs text-cover-text p-1">{contact.title}</p>
            )}
            {contact.licenseNo && (
              <p className="text-xs p-1">
                {contact.licenseNo}
              </p>
            )}
            {contact.phoneNumber && (
              <p className="text-xs p-1">
                <EmeraldIcon
                  icon="call"
                  type="filled"
                  className="text-primary mr-1 text-sm! align-middle"
                />{" "}
                {contact.phoneNumber}
              </p>
            )}
            {contact.email && (
              <p className="text-xs p-1">
                <EmeraldIcon
                  icon="email"
                  type="filled"
                  className="text-primary mr-1 text-sm! align-middle"
                />{" "}
                {contact.email}
              </p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ContactListPreview;
